module.exports = __webpack_public_path__ + "img/r-135.9a531cff.jpg";